// ─── Editable content ────────────────────────────────────────────────────────
// The HUD's one vocabulary for a slowdown span of time, shared by the Total
// Slowdown indicator (SafetyTaxIndicator) and the metric-details panel's NOW
// number (AlignedStatNumber): whole months under a year, years to one decimal
// from a year on, singular exactly at one.
export const SLOWDOWN_TIME_UNITS = {
  months: " mo",
  yearSingular: " yr",
  yearsPlural: " yrs",
}

// Module-level: Intl.NumberFormat construction is expensive and the panel
// calls this on every animation frame of a scroll date tween.
const SLOWDOWN_YEARS_FORMAT = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 1,
})

// The months/years switch happens on the ROUNDED month count (11.6 months
// reads "1 yr", not "12 mo") — the same boundary SafetyTaxIndicator's
// TickerNumber uses, so the HUD figure and the panel's big number can never
// disagree on vocabulary for the same value.
export const formatSlowdownYears = (years: number): string => {
  const roundedMonths = Math.round(years * 12)
  const displayedMonths = Object.is(roundedMonths, -0) ? 0 : roundedMonths
  if (Math.abs(displayedMonths) < 12) {
    return `${displayedMonths}${SLOWDOWN_TIME_UNITS.months}`
  }
  const suffix =
    Math.round(years * 10) === 10
      ? SLOWDOWN_TIME_UNITS.yearSingular
      : SLOWDOWN_TIME_UNITS.yearsPlural
  return `${SLOWDOWN_YEARS_FORMAT.format(years)}${suffix}`
}
